import type {
  BillingLocationData,
  CodingScreenState,
  PatientTypeInfoData
} from '../../project_starburst/interface';
import type { CaseSpecialtyData } from '../../project_starburst/interface/caseSpecialty';

/**
 * Patient-type and case-specialty edit deliberately share the facility edit gate: the single
 * `permission` argument comes from one `facilityEditPermission(caseRun, instance, userContext,
 * roles)` call in `coding-screen.tsx` and is fanned out to all three slots below. If one of their
 * editability rules ever needs to diverge, unwind it there -- compute a second permission and add a
 * second parameter here, rather than branching inside this function.
 */
export const injectFacilityPermission = (
  state: CodingScreenState,
  permission: 'allowed' | 'denied' | undefined
): CodingScreenState => {
  const billingLocation = state?.values?.['case.billingLocation'] as
    | BillingLocationData
    | undefined;
  const patientType = state?.values?.['case.patientType'] as
    | PatientTypeInfoData
    | undefined;
  const caseSpecialty = state?.values?.['case.specialty'] as
    | CaseSpecialtyData
    | undefined;
  if (!billingLocation && !patientType && !caseSpecialty) return state;
  return {
    ...state,
    values: {
      ...state.values,
      ...(billingLocation && {
        'case.billingLocation': { ...billingLocation, permission }
      }),
      ...(patientType && {
        'case.patientType': { ...patientType, permission }
      }),
      ...(caseSpecialty && {
        'case.specialty': { ...caseSpecialty, permission }
      })
    }
  };
};
